/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signingout1Inputs */

const en_signingout1 = /** @type {(inputs: Signingout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out...`)
};

const de_signingout1 = /** @type {(inputs: Signingout1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden…`)
};

/**
* | output |
* | --- |
* | "Signing out..." |
*
* @param {Signingout1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signingout1 = /** @type {((inputs?: Signingout1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signingout1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signingout1(inputs)
	return de_signingout1(inputs)
});
export { signingout1 as "signingOut" }